<template>
  <div class="d-flex justify-content-center align-items-center app-progress-bar">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-progress-bar {
  min-height: 12.5rem;
}
</style>
